import { useCallback } from 'react';

/**
 * Proposal History Preview Component
 * Shows last edit information on proposal card
 */
export function ProposalHistoryPreview({ lastEdit, onViewFullHistory }) {
  // Calculate time ago
  const getTimeAgo = useCallback((timestamp) => {
    if (!timestamp) return null;

    const date = new Date(timestamp);
    const seconds = Math.floor((new Date() - date) / 1000);

    if (seconds < 60) return 'just now';
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    if (seconds < 2592000) return `${Math.floor(seconds / 86400)}d ago`;
    return date.toLocaleDateString();
  }, []);

  if (!lastEdit) {
    return null;
  }

  const timeAgo = getTimeAgo(lastEdit.edited_at || lastEdit.timestamp);

  return (
    <div className="t24-history-preview">
      <div className="history-preview-content">
        <span className="history-icon">📝</span>
        <span className="history-text">
          {lastEdit.editor_name && (
            <span className="history-editor">{lastEdit.editor_name} </span>
          )}
          {lastEdit.change_summary ? (
            <span className="history-change">{lastEdit.change_summary}</span>
          ) : (
            <span className="history-change">Last edited</span>
          )}
          {timeAgo && (
            <span className="history-time"> {timeAgo}</span>
          )}
        </span>
      </div>

      {onViewFullHistory && (
        <button
          className="history-view-all"
          onClick={(e) => {
            e.stopPropagation();
            onViewFullHistory();
          }}
          aria-label="View full history"
        >
          View all changes
        </button>
      )}
    </div>
  );
}
